
import Vue from "vue";
import ActionButton from "@/components/atoms/ActionButton.vue";

export interface ActionButtonData {
  text: string;
}

export interface ActionButtonGroupProps {
  buttons: ActionButtonData[];
}

export default Vue.extend({
  name: "ActionButtonGroup",
  components: {
    ActionButton,
  },
  props: {
    buttons: {
      type: Array as () => ActionButtonData[],
      required: true,
    },
  },
  methods: {
    handleButtonClick(buttonText: string): void {
      this.$emit("button-click", buttonText);
    },
  },
});
